import { GithubContext } from '../context/context';
import $ from 'jquery';
import './LatestOppurtunity.css';
import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { useStore } from '../StoreContext';
import { Line } from 'react-chartjs-2';
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { IoArrowForward } from "react-icons/io5";
import { MdOutlineSchedule } from "react-icons/md";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const SingleOpportunity = (opportunity) => {
    const { isDesktop } = React.useContext(GithubContext);
    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        if (isDesktop) {
            setShowInfo(true)
        }
    }, [isDesktop])

    const goToOpportunity = (OppId) => {

        localStorage.setItem('OppId', `${OppId}`);
    }
    return (
        <div role="row" className={`opportunity-table-row ${showInfo ? 'active-show' : ''}`}>
            <>

                <div role="cell" className='opportunity-table-row-cell full-width'>
                    {!isDesktop &&
                        <div className='mobile-first-head'>
                            <p className='mobile-table-head'>Opportunity ID: {opportunity.opportunityId}</p>
                            <Link to="/oppurtunity-detail" onClick={() => goToOpportunity(opportunity.opportunityId)} className='view-link'>View</Link>
                        </div>
                    }
                    {isDesktop &&
                        <Link to="/oppurtunity-detail" onClick={() => goToOpportunity(opportunity.opportunityId)}>{opportunity.opportunityId}</Link>
                    }

                </div>
              
                <div role="cell" className='opportunity-table-row-cell full-width'>
                    {!isDesktop &&
                        <p className='mobile-table-head'>Account Name</p>
                    }
                    {opportunity.client_Name}
                </div>
                <div role="cell" className='opportunity-table-row-cell full-width mob-border'>
                    {!isDesktop &&
                        <p className='mobile-table-head'>Opportunity Name</p>
                    }
                    {opportunity.engagement_Name}
                </div>
                <div role="cell" className='opportunity-table-row-cell full-width'>
                    {!isDesktop &&
                        <p className='mobile-table-head'>Created On</p>
                    }
                    {opportunity.createdOn}
                </div>
                <div role="cell" className='opportunity-table-row-cell inline-flex'>
                    <div className="status-column">
                        {!isDesktop &&
                            <p className='mobile-table-head'>Jupiter</p>
                        }
                        {opportunity.jupiterStatus == 1 ? <div className='completed-text status'>C</div>
                            : opportunity.jupiterStatus == 2 ? <div className='progress-text status'>P</div>
                                : opportunity.jupiterStatus == 3 ? <div className='not-started-text status'>NS</div>
                                    : opportunity.jupiterStatus == 4 ? <div className='not-required-text status'>NR</div>
                                        : opportunity.jupiterStatus == 5 ? <div className='rejected-text status'>R</div>
                                            : opportunity.jupiterStatus == 6 ? <div className='closed-lost-text status'>CL</div>
                                                : opportunity.jupiterStatus == 0 ? <div className='not-started-text status'>NS</div>
                                                    : <div className='progress-text status'>P</div>
                        }
                    </div>
                </div>
                <div role="cell" className='opportunity-table-row-cell inline-flex'>
                    <div className="status-column">
                        {!isDesktop &&
                            <p className='mobile-table-head'>DRMS</p>
                        }
                        {opportunity.drmsStatus == 1 ? <div className='completed-text status'>C</div>
                            : opportunity.drmsStatus == 2 ? <div className='progress-text status'>P</div>
                                : opportunity.drmsStatus == 3 ? <div className='not-started-text status'>NS</div>
                                    : opportunity.drmsStatus == 4 ? <div className='not-required-text status'>NR</div>
                                        : opportunity.drmsStatus == 5 ? <div className='rejected-text status'>R</div>
                                            : opportunity.drmsStatus == 6 ? <div className='closed-lost-text status'>CL</div>
                                                : opportunity.drmsStatus == 0 ? <div className='not-started-text status'>NS</div>
                                                    : <div className='progress-text status'>P</div>
                        }
                    </div>
                </div>
                <div role="cell" className='opportunity-table-row-cell inline-flex'>
                    <div className="status-column">
                        {!isDesktop &&
                            <p className='mobile-table-head'>IRMS</p>
                        }
                        {opportunity.irmsStatus == 1 ? <div className='completed-text status'>C</div>
                            : opportunity.irmsStatus == 2 ? <div className='progress-text status'>P</div>
                                : opportunity.irmsStatus == 3 ? <div className='not-started-text status'>NS</div>
                                    : opportunity.irmsStatus == 4 ? <div className='not-required-text status'>NR</div>
                                        : opportunity.irmsStatus == 5 ? <div className='rejected-text status'>R</div>
                                            : opportunity.irmsStatus == 6 ? <div className='closed-lost-text status'>CL</div>
                                                : opportunity.irmsStatus == 0 ? <div className='not-started-text status'>NS</div>
                                                    : <div className='progress-text status'>P</div>
                        }
                    </div>
                </div>
                <div role="cell" className='opportunity-table-row-cell inline-flex'>

                    <div className="status-column">
                        {!isDesktop &&
                            <p className='mobile-table-head'>P2W</p>
                        }
                        {opportunity.pmsStatus == 1 ? <div className='completed-text status'>C</div>
                            : opportunity.pmsStatus == 2 ? <div className='progress-text status'>P</div>
                                : opportunity.pmsStatus == 3 ? <div className='not-started-text status'>NS</div>
                                    : opportunity.pmsStatus == 4 ? <div className='not-required-text status'>NR</div>
                                        : opportunity.pmsStatus == 5 ? <div className='rejected-text status'>R</div>
                                            : opportunity.pmsStatus == 6 ? <div className='closed-lost-text status'>CL</div>
                                                : opportunity.pmsStatus == 0 ? <div className='not-started-text status'>NS</div>
                                                    : <div className='progress-text status'>P</div>
                        }
                    </div>
                </div>
                {/*<div role="cell" className='opportunity-table-row-cell inline-flex'>*/}
                {/*    <div className="status-column">*/}
                {/*        {!isDesktop &&*/}
                {/*            <p className='mobile-table-head'>ECM</p>*/}
                {/*        }*/}
                {/*        {opportunity.ecmStatus == 1 ? <div className='completed-text status'>C</div>*/}
                {/*            : opportunity.ecmStatus == 2 ? <div className='progress-text status'>P</div>*/}
                {/*                : opportunity.ecmStatus == 3 ? <div className='not-started-text status'>NS</div>*/}
                {/*                    : opportunity.ecmStatus == 4 ? <div className='not-required-text status'>NR</div>*/}
                {/*                        : opportunity.ecmStatus == 5 ? <div className='rejected-text status'>R</div>*/}
                {/*                            : opportunity.ecmStatus == 6 ? <div className='closed-lost-text status'>CL</div>*/}
                {/*                                : opportunity.ecmStatus == 0 ? <div className='not-started-text status'>NS</div>*/}
                {/*                                    : <div className='progress-text status'>P</div>*/}
                {/*        }*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div role="cell" className='opportunity-table-row-cell inline-flex'>
                    <div className="status-column">
                        {!isDesktop &&
                            <p className='mobile-table-head'>WhizzPact</p>
                        }
                        {opportunity.ecmStatus == 1 ? <div className='completed-text status'>C</div>
                            : opportunity.ecmStatus == 2 ? <div className='progress-text status'>P</div>
                                : opportunity.ecmStatus == 3 ? <div className='not-started-text status'>NS</div>
                                    : opportunity.ecmStatus == 4 ? <div className='not-required-text status'>NR</div>
                                        : opportunity.ecmStatus == 5 ? <div className='rejected-text status'>R</div>
                                            : opportunity.ecmStatus == 6 ? <div className='closed-lost-text status'>CL</div>
                                                : opportunity.ecmStatus == 0 ? <div className='not-started-text status'>NS</div>
                                                    : <div className='progress-text status'>P</div>
                        }
                    </div>
                </div>
                <div role="cell" className='opportunity-table-row-cell inline-flex'>
                    <div className="status-column">
                        {!isDesktop &&
                            <p className='mobile-table-head'>Swift</p>
                        }
                        {opportunity.sapStatus == 1 ? <div className='completed-text status'>C</div>
                            : opportunity.sapStatus == 2 ? <div className='progress-text status'>P</div>
                                : opportunity.sapStatus == 3 ? <div className='not-started-text status'>NS</div>
                                    : opportunity.sapStatus == 4 ? <div className='not-required-text status'>NR</div>
                                        : opportunity.sapStatus == 5 ? <div className='rejected-text status'>R</div>
                                            : opportunity.sapStatus == 6 ? <div className='closed-lost-text status'>CL</div>
                                                : opportunity.sapStatus == 0 ? <div className='not-started-text status'>NS</div>
                                                    : <div className='progress-text status'>P</div>
                        }
                    </div>
                </div>
            </>

        </div>
    )
}

const OpportunitiesDeatils = ({ opportunities, currentPage, setCurrentPage }) => {

    const { isDesktop } = React.useContext(GithubContext);
    const tableHeadCell = ['opportunity-table-header-cell', isDesktop ? '' : "mobile-hide"].join(' ');
    const recordsPerPage = 5;
    const lastIndex = currentPage * recordsPerPage;
    const firstIndex = lastIndex - recordsPerPage;
    const records = opportunities.slice(firstIndex, lastIndex);
    const npage = Math.ceil(opportunities.length / recordsPerPage);
    const numbers = [...Array(npage + 1).keys()].slice(1);



    return (
        <>

            <div className='opportunity-table-block'>
                <div className='opportunity-table' role="table" aria-label="Opportunity Lists Table">
                    <div role="row" className='opportunity-table-header'>
                        <div role="columnheader" className={tableHeadCell}>Opportunity ID</div>
                        <div role="columnheader" className={tableHeadCell}>Account Name</div>
                        <div role="columnheader" className={tableHeadCell}>Opportunity Name</div>
                        <div role="columnheader" className={tableHeadCell}>Created On</div>
                        <div role="columnheader" className={`opportunity-table-header-cell text-center ${isDesktop ? '' : "mobile-hide"}`}>Jupiter</div>
                        <div role="columnheader" className={`opportunity-table-header-cell text-center ${isDesktop ? '' : "mobile-hide"}`}>DRMS</div>
                        <div role="columnheader" className={`opportunity-table-header-cell text-center ${isDesktop ? '' : "mobile-hide"}`}>IRMS</div>
                        <div role="columnheader" className={`opportunity-table-header-cell text-center ${isDesktop ? '' : "mobile-hide"}`}>P2W</div>
                        {/*<div role="columnheader" className={`opportunity-table-header-cell text-center ${isDesktop ? '' : "mobile-hide"}`}>ECM</div>*/}
                        <div role="columnheader" className={`opportunity-table-header-cell text-center ${isDesktop ? '' : "mobile-hide"}`}>WhizzPact</div>
                        <div role="columnheader" className={`opportunity-table-header-cell text-center ${isDesktop ? '' : "mobile-hide"}`}>Swift</div>
                    </div>

                    <div className='opportunity-table-body' role="status" aria-live="assertive" aria-atomic="true">
                        {records.length > 0 ?
                            records.map((opportunity) => {
                                return (
                                    <SingleOpportunity key={opportunity.opportunityId} {...opportunity}></SingleOpportunity>
                                )
                            }) : ''
                        }

                    </div>
                </div>
            </div>
            {/* Pagination start */}
            {records.length > 0 ?
                <ul className="pagination" role="navigation" aria-label="Pagination">

                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}><button role='button' disabled={currentPage === 1} aria-disabled={currentPage === 1 ? 'true' : 'false'} tabIndex="0" aria-label="Previous page" className="page-link" onClick={prepage}>Previous</button></li>
                    {
                        numbers.map((n, i) => (
                            <li className='page-item' key={i}>
                                <button role='button' className={`page-link ${currentPage === n ? 'active' : ''}`} tabIndex="0" aria-label={`Go to page ${n}`} aria-current={currentPage === n ? 'page' : undefined} onClick={() => changeCPage(n)}>{n}</button>
                            </li>
                        ))
                    }
                    <li className={`page-item ${currentPage === npage ? 'disabled' : ''}`}><button role='button' disabled={currentPage === npage} aria-disabled={currentPage === npage ? 'true' : 'false'} tabIndex="0" aria-label="Next page" className="page-link" onClick={nextpage}>Next</button></li>
                </ul> : ''
            }
            {/* Pagination end */}




        </>
    )
    function prepage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id)
    }
    function nextpage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
}


const LatestOppurtunity = () => {
    const [isLoading, setIsLoading] = useState(true);
    const loaderRef = useRef(null);
    const resultsRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const { searchText, setSearchText, startSearch, setStartSearch, setIsAdvanced, IsAdvanced, JupDurselectedValue, setJupDurselectedValue,
        JupSalselectedValue, IndustryselectedValue, searchClientNameText, setClientNameText, searchOppLeaderText, setOppLeaderText,
        searchOppSpltLeaderText, setOppSplitLeaderText,topRowSelectedValue, settopRowSelectedValue } = useStore();
    //const UserId = localStorage.getItem("userId")

    const [Opportunities, setOpportunities] = useState([]);
    const { isDesktop } = React.useContext(GithubContext);
    const [showInfo, setShowInfo] = useState(false);
    const tableHeadCell = ['opportunity-table-header-cell', isDesktop ? '' : "mobile-hide"].join(' ');
    const [Analytics, setAnalytics] = useState([]);
   
    //var str = "[" + [Analytics.length > 0 ? Analytics[0].xValues[0].values : ''] + "]" ;
    //console.log(JSON.stringify(Analytics.length > 0 ? Analytics[0].xValues[0].values:''));

    function parseValues(str) {
        if (typeof str !== 'string') {
            return [];
        }
        return str
            .split(',')
            .map(item => item.trim().replace(/'/g, ''));
    }

    const xValuesArray = parseValues(Analytics[0]?.xValues[0]?.values).map(Number);
    const yValuesArray = parseValues(Analytics[0]?.yValues[0]?.values);
    const O2EClosedCount = parseValues(Analytics[0]?.o2EClsoedCount[0]?.values);
    const ClosedWonCount = parseValues(Analytics[0]?.o2EClsoedWonCount[0]?.values);
    const VerbalCommitCount = parseValues(Analytics[0]?.o2EVerbalCommitCount[0]?.values);

    const data = {
        
        labels: yValuesArray,
        datasets: [
            {
                label: 'Opportunities',
                data: xValuesArray ,
                fill: true,
                backgroundColor: "rgba(75,192,192,1)",
                borderColor: "#86BC25",
                pointBackgroundColor: "#86BC25",
                pointBorderColor: "#86BC25",
                //pointBorderWidth: 2, 
                //pointRadius: 5, 
                tension: 0.7,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                display: false,
            },
            y: {
                display: false,
            },
        },
        elements: {
            line: {
                borderWidth: 1,
            },
        },
        layout: {
            padding: {
                left: 5,
                right: 5,
                top: 5,
                bottom: 5,
            },
        },
        grid: {
            display: true,
        },
    };


    useEffect(() => {
        if (!isLoading && searchText?.length > 0 && resultsRef.current) {
            resultsRef.current.focus();
        }
        fetchAnalytics();
    }, [Opportunities, isLoading]);


   

    const fetchOpportunities = () => {



        if (IsAdvanced) {
            console.log("Advanced Search Part");
            var JupValue = "";
            if (JupDurselectedValue !== undefined && JupDurselectedValue !== "") {

                JupValue = JupDurselectedValue.value;
            }
            else {
                JupValue = "";
            }
            var topRows = "";
            if (topRowSelectedValue !== undefined && topRowSelectedValue !== "") {

                topRows = topRowSelectedValue.value;
            }
            else {
                topRows = "50";
            }

            var JupSaleStageValue = "";
            if (JupSalselectedValue !== undefined && JupSalselectedValue.length > 0) {
                JupSaleStageValue = JupSalselectedValue.map(item => `'${item.value}'`).join(', ');
            }
            else {
                JupSaleStageValue = "";
            }

            var JupIndustryValue = "";
            if (IndustryselectedValue !== undefined && IndustryselectedValue.length > 0 ) {
                JupIndustryValue = IndustryselectedValue.map(item => `'${item.value}'`).join(', ');
            }
            else {
                JupIndustryValue = "";
            }
            var ClientName = "";
            if (searchClientNameText !== undefined && searchClientNameText.length > 0) {

                ClientName = searchClientNameText;
            }
            else {
                ClientName = "";
            }

            var OppLeader = "";
            if (searchOppLeaderText !== undefined && searchOppLeaderText.length > 0) {

                OppLeader = searchOppLeaderText;
            }
            else {
                OppLeader = "";
            }

            var OppSplitLeader = "";
            if (searchOppSpltLeaderText !== undefined && searchOppSpltLeaderText.length > 0) {

                OppSplitLeader = searchOppSpltLeaderText;
            }
            else {
                OppSplitLeader = "";
            }

            setIsLoading(true);
            fetch('jupiterdata/GetAdvancedSearchData', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    O2EStatus: JupValue,
                    Rows: topRows,
                    Duration: '',
                    ClientName: ClientName,
                    SplitLeader: OppSplitLeader,
                    SaleStage: JupSaleStageValue,
                    UserId: localStorage.getItem("userId"),
                    Industry: JupIndustryValue,
                    OppLeader: OppLeader,
                }),
            }).then(response => {
                        return response.json();
                    }).then(data => {
                        if (data.length > 0) {
                            setOpportunities(data);
                            //localStorage.removeItem("SearcOpp");
                            if (!isLoading && searchText?.length > 0 && resultsRef.current) {
                                resultsRef.current.focus();
                            }
                            setIsLoading(false);
                        }
                        else {
                            setOpportunities(data);
                            //localStorage.removeItem("SearcOpp");
                            if (!isLoading && searchText?.length > 0 && resultsRef.current) {
                                resultsRef.current.focus();
                            }
                            setIsLoading(false);
                        }
                    }).catch(function (err) {
                        console.log('SOMETHING WENT WRONG');
                        setIsLoading(false);
                    });

           

        }
        else {
            if (searchText !== undefined) {
                if (searchText.length > 0) {
                    setIsLoading(true);
                    fetch('jupiterdata/GetData/' + searchText + '/' + localStorage.getItem("userId")).then(response => {
                        return response.json();
                    }).then(data => {
                        if (data.length > 0) {
                            setOpportunities(data);
                            //localStorage.removeItem("SearcOpp");
                            if (!isLoading && searchText?.length > 0 && resultsRef.current) {
                                resultsRef.current.focus();
                            }
                            setIsLoading(false);
                        }
                        else {
                            setOpportunities(data);
                            //localStorage.removeItem("SearcOpp");
                            if (!isLoading && searchText?.length > 0 && resultsRef.current) {
                                resultsRef.current.focus();
                            }
                            setIsLoading(false);
                        }
                    }).catch(function (err) {
                        console.log('SOMETHING WENT WRONG');
                        setIsLoading(false);
                    });
                    //.catch((error) => { console.log(error); setIsLoading(false); })

                }
                else {

                    console.log("Search Part Else")
                    setIsLoading(true);
                    fetch('jupiterdata/GetData/All/' + localStorage.getItem("userId")).then(response => {
                        return response.json();
                    }).then(data => {
                        setOpportunities(data);
                        setIsLoading(false);
                    }).catch(function (err) {
                        console.log('SOMETHING WENT WRONG');
                        setIsLoading(false);
                    });
                }
            }
            else {
                setIsLoading(true);
                console.log("Search Main Part")
                fetch('jupiterdata/GetData/All/' + localStorage.getItem("userId")).then(response => {
                    return response.json();
                }).then(data => {
                    setOpportunities(data);
                    console.log(data);
                    setIsLoading(false);
                }).catch(function (err) {
                    console.log('SOMETHING WENT WRONG');
                    setIsLoading(false);
                });
            }
        }
    }

    useEffect(() => {
        fetchOpportunities();
        setCurrentPage(1)
        
    }, [startSearch])

    useEffect(() => {
        if (isDesktop) {
            setShowInfo(true)
        }

    }, [isDesktop])

    const fetchAnalytics = () => {
      
        fetch('jupiterdata/GetAnalyticData/' + localStorage.getItem("userId"))
            .then(res => res.json())
            .then(data => setAnalytics(data))
            .catch(err => console.error('Error fetching categories:', err));
        
    }
   

    useEffect(() => {
        if (isLoading && loaderRef.current) {
            const loaderElement = loaderRef.current;

            const handleTabKey = (e) => {
                if (e.key === 'Tab') {
                    e.preventDefault();
                    if (document.activeElement !== loaderElement) {
                        loaderElement.focus();
                    }
                }
            };
            loaderElement.focus();

            document.addEventListener('keydown', handleTabKey);

            return () => {
                document.removeEventListener('keydown', handleTabKey);
            };
        }
    }, [isLoading]);

    useEffect(() => {
        const userName = localStorage.getItem("OppId")
        if (userName === "undifined" || userName === "" || userName === null) {
            $('#staticsModal').modal('show');
        }
    },[])

    const goToLikeBtnclick = (e) => {
            //console.log("LogActivity")
            fetch(`logincall/Feedback/${localStorage.getItem("userId")}/Yes`).then(response => {
                return response.json();
            }).then(data => {
                $('#staticsModal').modal('hide');
                alert(data[0].feedback);
            })
    }

    const goToDisLikeBtnclick = (e) => {
        //console.log("LogActivity")
        fetch(`logincall/Feedback/${localStorage.getItem("userId")}/No`).then(response => {
            return response.json();
        }).then(data => {
            $('#staticsModal').modal('hide');
            alert(data[0].feedback);
        })
    }
    return (
        <>
            <div className="oppurtunity-left">
                <div ref={resultsRef} role="status" aria-live="assertive" aria-atomic="true">
                    {Opportunities.length > 0 && (
                        <>
                           <div className='total-opp'>
                                <h2 className='mb-2 opp-length'>Total Opportunities: {Opportunities.length}</h2>
                                <div className=''>
                                    <Link className='btn advanced-btn h-auto mb-2 py-0' target='_blank' to="https://app.powerbi.com/links/U_Y0Za6TXo?ctid=36da45f1-dd2c-4d1f-af13-5abe46b99921&pbi_source=linkShare">Go To O2E Dashboard <IoArrowForward /></Link>
                                </div>
                           </div>
                            <OpportunitiesDeatils opportunities={Opportunities} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                            {/* Status List Start */}
                            <ul className="status-list">
                                <li className="status-item ">
                                    <div className="completed-icon-status status-item-icon">C</div>
                                    Completed
                                </li>
                                <li className="status-item ">
                                    <div className="progress-icon-status status-item-icon">P</div>
                                    In Progress
                                </li>
                                <li className="status-item">
                                    <div className="not-started-icon-status status-item-icon">NS</div>
                                    Not Started
                                </li>
                                <li className="status-item">
                                    <div className="not-required-icon-status status-item-icon">NR</div>
                                    Not Required
                                </li>
                                <li className="status-item">
                                    <div className="rejected-icon-status status-item-icon">R</div>
                                    Rejected
                                </li>
                                <li className="status-item">
                                    <div className="closed-lost-icon-status status-item-icon">CL</div>
                                    Closed Lost
                                </li>
                            </ul>
                            {/* Status List End */}
                        </>
                    )}
                </div>
                <div ref={resultsRef} role="status" aria-live="assertive" aria-atomic="true" tabIndex="0">
                    {Opportunities.length == 0 && !isLoading && <h2 className='mb-2 opp-length'>No Records Found</h2>}
                </div>
            </div>
            {isLoading && <div className="preloader" role="status" aria-live="assertive" tabIndex="0" ref={loaderRef} aria-label="Loading Opportunity List, please wait...">
                <div className="loader">
                    <div></div><div></div><div></div>
                </div>
            </div>}

            {/* <div className='statistics-sticky-btn' data-toggle="modal" data-target="#staticsModal">
                <img src='../image/statistics.svg' alt='' />
            </div> */}
            <div class="modal new-modal" id="staticsModal">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Analytics</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div className='kpi-lists' style={{ alignItems: 'start' }}>
                                <div className='kpi-item default-color brand-bg-color' style={{ flexBasis: '40%' }}>
                                    {/*<p className=''>Was this information helpful?</p>*/}
                                    <div className='kpi-count'>Closed Won Opportunities in Last 5 Month</div>
                                    <Line data={data} options={options} height={100} />
                                </div>
                            </div>
                            <h1 className='kpi-count'>Current Financial Year</h1>
                            <div className='kpi-lists'>
                                <div className='kpi-item dark-green-color'>
                                    <div className='kpi-title'> O2E Process <br />Closed</div>
                                    <div className='kpi-count'>{O2EClosedCount}</div>
                                </div>
                                <div className='kpi-item blue-color'>
                                    <div className='kpi-title'>Closed Won <br />Opportunities</div>
                                    <div className='kpi-count'>{ClosedWonCount}</div>
                                </div>
                                <div className='kpi-item blue-color'>
                                    <div className='kpi-title'>Verbal Commit <br />Opportunities</div>
                                    <div className='kpi-count'>{VerbalCommitCount}</div>
                                </div>
                            </div>
                        </div>
                        <div className='likes-btn'>
                            <button type='button' onClick={(e) => goToLikeBtnclick(e)} className='btn like-btn'><AiOutlineLike /> Like</button>
                            <button type='button' onClick={(e) => goToDisLikeBtnclick(e)} className='btn dislike-btn'><AiOutlineDislike /> Dislike</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal new-modal" id="analyticalModal">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Analytics</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div className='kpi-lists' style={{ alignItems: 'start' }}>
                                <div className='kpi-item default-color brand-bg-color' style={{ flexBasis: '40%' }}>
                                    <p className=''>Average days to opportumity fromJupiter to Swift </p>
                                    <div className='kpi-count'>200</div>
                                    <Line data={data} options={options} height={100} />
                                </div>
                                <div className='kpi-item dark-green-color'>
                                    <div className='kpi-title'>Closed <br />Opportunities</div>
                                    <div className='kpi-count'>200</div>
                                </div>
                            </div>
                            <div className='kpi-lists'>
                                <div className='kpi-item brand-color'>
                                    <div className='kpi-title'>Closed <br />Opportunities</div>
                                    <div className='kpi-count'>200</div>
                                </div>
                                <div className='kpi-item blue-color'>
                                    <div className='kpi-title'>Sample text</div>
                                    <div className='kpi-count'>200</div>
                                </div>
                                <div className='kpi-item light-green-color'>
                                    <div className='kpi-title'>Open <br />Opportunities</div>
                                    <div className='kpi-count'>200</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>)
}

export default LatestOppurtunity;